import AllthingsModule from './containers/allthingsModule'

export {default as AllthingsModuleLayout} from './components/allthingsModuleLayout'

export default AllthingsModule
